import React from 'react';

var TransferRevokePopup = React.createClass({
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	handleCancelClick: function(){
		this.props.transferRevoke("close");
	},
	handleRevokeClick: function(){
		this.props.transferRevoke("close");
	},
	render: function(){
		return (
				<div className="modal__mask" onClick = {this.handleCancelClick}>
				  <div className="modal__content modal--sm" onClick = {this.handleStopPropogation}> 
				  	<a href="javascript:void(0)" className="modal__close" onClick = {this.handleCancelClick}><i className="fa  fa-close"> </i></a>
				    <div className="modal__body clearfix">
				      <div className="form__row">
				        <p>Are you sure you want to revoke your transfer to <strong>legutierr</strong> for package <strong>"Remodeling Theme"</strong>?</p>
				      </div>
				      <div className="buttons">
				        <button className="btn__md bg-very_light" onClick = {this.handleCancelClick}>Cancel</button>
				        <button className="btn__md bg-bold" onClick = {this.handleRevokeClick}>Revoke</button>
				      </div>
				    </div>
				  </div>
				</div>
		);
	}
});

export {TransferRevokePopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/TransferRevokePopup.jsx
 **/